import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router  } from '@angular/router';
import { LoginService } from '../../services/login/login.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-reset-password-page',
  templateUrl: './reset-password-page.component.html',
  styleUrls: ['./reset-password-page.component.scss']
})
export class ResetPasswordPageComponent implements OnInit {
  public form: FormGroup;
  public loading = false;
  public errorMessage?: string;
  public attemptedSubmit = false;
  public successfullySent = false;

  private token: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(this.onRouteParameterChange.bind(this));

    this.form = new FormGroup({
      password: new FormControl('', [Validators.required, Validators.minLength(8)]),
      passwordConfirm: new FormControl('', [Validators.required])
    }, this.checkPasswords);
  }

  onRouteParameterChange(params) {
    if (!params || !params.token) {
      return this.router.navigate(['/login']);
    }
    this.token = params.token;
  }

  checkPasswords(group: FormGroup) {
    const password = group.get('password').value;
    const passwordConfirm = group.get('passwordConfirm').value;

    return password === passwordConfirm ? null : { notSame: true };
  }

  get password(): FormControl { return this.form.get('password') as FormControl; }
  get passwordConfirm(): FormControl { return this.form.get('passwordConfirm') as FormControl; }

  async onSubmitClick() {
    this.errorMessage = '';
    this.attemptedSubmit = true;
    if (this.form.invalid) {
      if (!this.form.dirty) {
        this.form.markAsDirty();
      }
      return;
    }
    const password = this.password.value;
    const passwordConfirm = this.passwordConfirm.value;
    const token = this.token;
    this.loading = true;
    try {
      const response = await this.loginService.changeForgottenPassword(password, passwordConfirm, token);
      if (response === true) {
        this.successfullySent = true;
        setTimeout(this.redirectToLogin.bind(this), 3000);
      } else {

      }
    } catch(err) {
      if (typeof err.message !== "string" || !err.message) {
        console.error(err);
      }
      this.loading = false;
      this.attemptedSubmit = false; // Supress form validation errors
      this.errorMessage = ((err && err.message ? err.message : err) || "Unknown error").toString();
    }
    this.loading = false;
  }

  redirectToLogin() {
    console.log('Redirecting to login');
    this.router.navigate(['/login']);
  }
}
